import { Star } from "lucide-react";

export function ProductRating({
  rating,
  reviews
}: {
  rating: number;
  reviews?: number;
}) {
  return (
    <div className="flex items-center">
      <Star className="mr-1 h-2.5 w-2.5 fill-yellow-400 text-yellow-400 sm:h-3 sm:w-3" />
      <span>
        {rating}
        {Number.isInteger(reviews) ? ` (${reviews})` : null}
      </span>
    </div>
  );
}
